import React, { useRef, useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";

import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Select from 'react-select';
import CreateSlug from "../components/extra/CreateSlug";
import NavBar from "../components/NavBar";


const Home = () => {


  const {

    isLayoutLoading,
    layout, splashScreen, AllHomeProducts, isProducts, AllProducts, Headers, IsBlogLoading, AllBlogs, AllCategoriess, LocationHeaders
  } = useBlogContext();




  const sliderRef = useRef(null);



  const isVideo = (url) => /\.(mp4|webm|ogg)$/i.test(url);



  const tags = [
    "Anklets",
    "Bracelets",
    "Accessories",
    "Engagement Ring",
    "Chains",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const swiperRef = useRef();

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };


  const [formData, setFormData] = useState({});


  //   const filteredLocations = LocationHeaders.filter((location) =>
  //   location.toLowerCase().includes(searchQuery.toLowerCase())
  // );



  const navigate = useNavigate();


  const [goldRates, setGoldRates] = useState({});
  const [silverPrice, setSilverPrice] = useState(null);

  useEffect(() => {
    const gold10gm = Number(Headers?.gold || 0);
    const silver10gm = Number(Headers?.sliver || 0);

    // Convert 10gm to 1gm.
    const goldPerGram = gold10gm / 10;
    const silverPerGram = silver10gm / 10;

    setGoldRates({
      "24KT": goldPerGram,
      "22KT": goldPerGram * (22 / 24),
      "18KT": goldPerGram * (18 / 24),
      "14KT": goldPerGram * (14 / 24),
    });

    setSilverPrice(silverPerGram);
  }, [Headers]);

  const formatRate = (rate) => (
    rate ? Math.floor(rate).toLocaleString("en-IN") : "Loading..."
  );

  const rateSlides = [
    [
      { metal: "Gold", purity: "24KT", rate: goldRates["24KT"], iconClass: "gold" },
      { metal: "Gold", purity: "22KT", rate: goldRates["22KT"], iconClass: "gold" },
    ],
    [
      { metal: "Gold", purity: "18KT", rate: goldRates["18KT"], iconClass: "gold" },
      { metal: "Gold", purity: "14KT", rate: goldRates["14KT"], iconClass: "gold" },
    ],
    [
      { metal: "Silver", purity: "999", rate: silverPrice, iconClass: "silver" },
    ],
  ];



  return (
    <>


      <Header />


      <main className="W-100 page-content space-top mt-0 p-b50 overflow-hidden px-0"  >



        {/* 
        <div className="search-box">
          <div className="input-group">
            <input type="search" placeholder="Search" className="form-control" />
            <span className="input-group-text">
              <i className="feather icon-search" />
            </span>
          </div>
        </div> */}

        <div className="pb-2 position-relative mb-3 px-3"
          style={{ zIndex: 2 }} >


          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={false}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1.2,
              },
              1024: {
                slidesPerView: 1.2,
              },
            }}
            ref={swiperRef}
            autoplay={{
              delay: 2000,
              pauseOnMouseEnter: true,
            }}

            loop={true}
            centeredSlides={true}
            modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 align-items-center" >

            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <SwiperSlide
                  className="skeleton rounded-4"
                  style={{
                    width: "100%",
                    aspectRatio: "1800/675"
                  }}
                ></SwiperSlide>
              ))
              : (
                <>

                  {layout.home_slider && (
                    <>
                      {layout.home_slider.map((image, index) => (

                        <SwiperSlide key={index}
                          className="skeleton rounded-4"
                          style={{
                            width: "100%",
                            aspectRatio: "1800/675"
                          }} >
                          <div className="link-dark">
                            <img
                              className="img-fluid w-100 rounded-4"
                              src={image}
                              alt="Preview"
                              id={`imageinputN1${index + 1}`}
                            />
                          </div>
                        </SwiperSlide>


                      ))}
                    </>
                  )}


                </>
              )}


          </Swiper>

        </div>

        {/* goldrates section start  */}
        <section className="px-3 mb-3 position-relative" id="goldrates">
          <div className="gold-rate-panel" onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <div className="gold-rate-heading">
              <span className="gold-rate-kicker">Today Rate</span>
              <h4>Gold & Silver Price</h4>
            </div>
            <Swiper
              slidesPerView={1}
              spaceBetween={16}

              navigation={true}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
              }}
              ref={swiperRefLocal}
              autoplay={{
                delay: 2200,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              modules={[Pagination, Navigation, Autoplay]} className="gold-rate-swiper book-now pb-0">

              {isLayoutLoading && !Headers
                ? Array.from({ length: 4 }).map((_, index) => (
                  <SwiperSlide
                    key={index}
                    className="gold-rate-skeleton skeleton"
                  ></SwiperSlide>
                ))
                : rateSlides.map((slide, slideIndex) => (
                  <SwiperSlide key={slideIndex}>
                    <div className={`gold-rate-grid ${slide.length === 1 ? "single-rate" : ""}`}>
                      {slide.map((item) => (
                        <div className="gold-rate-card" key={`${item.metal}-${item.purity}`}>
                          <div className={`rate-icon ${item.iconClass}`}>
                            <i className="ri-coin-fill" />
                          </div>
                          <div className="rate-copy">
                            <span>{item.metal} Rate</span>
                            <strong>{item.purity}</strong>
                          </div>
                          <div className="rate-value">
                            <span>Rs.</span>{formatRate(item.rate)}
                            <small>/ gm</small>
                          </div>
                        </div>
                      ))}
                    </div>
                  </SwiperSlide>
                ))
              }

            </Swiper>
          </div>
        </section>


        {/* goldrates section end  */}


        <div className="dz-category">

          <div className="title-bar">
            <h4 className="title p-r50">
              Explore Categories
            </h4>
          </div>


          <Swiper
            breakpoints={{
              300: { slidesPerView: 3.2 },
              640: { slidesPerView: 3.2 },
              768: { slidesPerView: 5 },
              1024: { slidesPerView: 6 },
            }}
            spaceBetween={16}
            loop={true}
            // autoplay={{
            //   delay: 2500,
            //   disableOnInteraction: false,
            // }}

            modules={[Autoplay]}
            className="dz-category-swiper"
          >
            {isLayoutLoading ? (
              Array.from({ length: 6 }).map((_, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="skeleton rounded-circle"
                    style={{
                      aspectRatio: "1/1",
                      borderRadius: "12px",
                    }}
                  />
                </SwiperSlide>
              ))
            ) : (
              layout?.trending_product_banner?.map((item, index) => (
                <SwiperSlide key={index}>

                  <div className="dz-category-items justify-content-center w-100">
                    <Link to={item?.imageUrlInput} className="dz-media">
                      <img src={item?.imageInput}
                        alt={item?.imageTITInput} />
                    </Link>
                    <h6 className="title small text-white w-100 ">
                      <Link to={item?.imageUrlInput} className="small text-white w-100 text-center" >     {item?.imageTITInput} </Link>
                    </h6>
                  </div>

                </SwiperSlide>
              ))
            )}
          </Swiper>



        </div>


        <div className="dz-category mt-4 style-4">
          <div className="title-bar">
            <h4 className="title">Featured now</h4>
            <Link to="/All">See All</Link>
          </div>

          <Swiper
            slidesPerView="auto"
            spaceBetween={16}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              300: { slidesPerView: 2.5 },
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 4 },
            }}
            modules={[Autoplay]}
            className="featured-swiper mt-4"
          >
            {(AllProducts && isLayoutLoading) ? Array.from({ length: 6 }).map((_, i) => (
              <SwiperSlide key={i} >


                <div
                  className="cart-list style-2 "
                  style={{ height: 100, borderRadius: 10 }}
                >
                  <div className="dz-media media-75 skeleton " />
                  <div className="dz-content">
                    <h6 className="title skeleton" style={{ height: 10 }} />


                    <ul className="dz-meta">
                      <li className="dz-price skeleton" style={{ height: 10 }}>

                      </li>

                      <li className="dz-review skeleton" style={{ height: 10 }}>

                      </li>
                    </ul>


                    <div className="dz-off skeleton" style={{ height: 10 }} />

                  </div>

                </div>
              </SwiperSlide>
            ))
              : AllProducts.filter(product =>
                layout?.trending_product?.includes(product._id)
              ).map((product) => (
                <SwiperSlide
                  key={product._id}

                >
                  <div className="dz-card p-0">
                    <div className="dz-media">
                      <Link to={`/product/${product.slug}`}>
                        {isVideo(product.pImage) ? (
                          <video
                            src={product.pImage}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="img-fluid"
                          />
                        ) : (
                          <img
                            src={product.pImage || "/assets/img/square-placeholder.jpg"}
                            alt={product.title}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/assets/img/square-placeholder.jpg";
                            }}
                          />
                        )}
                      </Link>

                      {/* Wishlist Button */}
                      <button
                        type="button"
                        className="item-bookmark"
                      >
                        <i className="feather icon-heart"></i>
                      </button>
                    </div>

                    <div className="dz-content">
                      <h5 className="title truncate-two-lines small">
                        <Link to={`/product/${product.slug}`}>
                          {product.title}
                        </Link>
                      </h5>

                      <div className="dz-price">
                        ₹{product.salePrice}
                        {product.regularPrice > product.salePrice && (
                          <del>₹{product.regularPrice}</del>
                        )}
                      </div>

                      {product.regularPrice > product.salePrice && (
                        <div className="dz-off">
                          {Math.round(
                            ((product.regularPrice - product.salePrice) /
                              product.regularPrice) *
                            100
                          )}
                          % Off
                        </div>
                      )}

                      {/* Add To Cart Button */}
                      {/* <button
                        type="button"
                        className="cart-btn"
                      >
                        <i className="ri-add-line"></i>
                      </button> */}
                    </div>
                  </div>


                </SwiperSlide>
              ))}
          </Swiper>
        </div>


        <section className="my-4">

          {isLayoutLoading
            ? Array.from({ length: 4 }).map((_, index) => (
              <div
                className="skeleton"
                style={{
                  width: "100%",
                  aspectRatio: "197/90"
                }}
              ></div>
            ))
            : (
              <>

                {layout.trending_product_carousal && (
                  <>
                    {layout.trending_product_carousal.map((image, index) => (

                      <img key={index} src={image?.imageInput} className="d-block w-100 mb-4" alt="banner" />


                    ))}
                  </>
                )}

              </>)}




        </section>

        <div className="dz-category mt-4 style-4">
          <div className="title-bar">
            <h4 className="title">Best Selling</h4>
            <Link to="/All">See All</Link>
          </div>

          <Swiper
            slidesPerView="auto"
            spaceBetween={16}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="featured-swiper mt-4"
          >
            {(AllProducts && isLayoutLoading) ? Array.from({ length: 6 }).map((_, i) => (
              <SwiperSlide key={i} style={{ width: "250px" }}>
                <div
                  className="cart-list style-2 "
                  style={{ height: 100, borderRadius: 10 }}
                >
                  <div className="dz-media media-75 skeleton " />
                  <div className="dz-content">
                    <h6 className="title skeleton" style={{ height: 10 }} />


                    <ul className="dz-meta">
                      <li className="dz-price skeleton" style={{ height: 10 }}>

                      </li>

                      <li className="dz-review skeleton" style={{ height: 10 }}>

                      </li>
                    </ul>


                    <div className="dz-off skeleton" style={{ height: 10 }} />

                  </div>

                </div>
              </SwiperSlide>
            ))
              : AllProducts.filter(product =>
                layout?.best_selling_laptop?.includes(product._id)
              ).map((product) => (
                <SwiperSlide
                  key={product._id}
                  style={{ width: "250px" }}
                >
                  <div className="cart-list style-2">
                    <div className="dz-media media-75">
                      {isVideo(product.pImage) ? (
                        <video
                          src={product.pImage}
                          autoPlay
                          muted
                          loop
                          playsInline
                          className="img-fluid"
                        />
                      ) : (
                        <img
                          src={product.pImage ?? 'none'}
                          alt={product.title}
                          onError={(e) => {
                            e.target.onerror = null; // prevents infinite loop
                            e.target.src = "/assets/img/square-placeholder.jpg";
                          }}
                        />
                      )}
                    </div>

                    <div className="dz-content">
                      <h6 className="title truncate-two-lines">
                        <Link to={`/product/${product.slug}`}>
                          {product.title}
                        </Link>
                      </h6>

                      <ul className="dz-meta ps-0">
                        <li className="dz-price">
                          ₹{product.salePrice}
                          <del>
                            ₹{product.regularPrice}
                          </del>
                        </li>

                        {/* <li className="dz-review">
                          <i className="feather icon-star-on"></i>
                          <span>(2k Review)</span>
                        </li> */}
                      </ul>

                      {product.regularPrice > product.salePrice && (
                        <div className="dz-off">
                          {Math.round(
                            ((product.regularPrice -
                              product.salePrice) /
                              product.regularPrice) *
                            100
                          )}
                          % Off
                        </div>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>


      </main>


      <NavBar />

    </>
  );
};

export default Home;
